import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'
import { TYPES } from '@md/users/constances'

const List = () => import('./views/List')
const Display = () => import('./views/Display')

export const EMES_ORDERS_ROLES = [
  TYPES.ADMINISTRATOR,
  TYPES.MANAGER,
  TYPES.MANAGER_WAREHOUSE,
  TYPES.STORE_WH,
  TYPES.ACCOUNTANT,
]

export function createRoutes(options) {
  return [
    route('list/', List, 'profile:emes-orders:list', {
      meta: { accessConfig: accessPermission(EMES_ORDERS_ROLES, options) },
    }),
    route(':id/', Display, 'profile:emes-orders:display', {
      props: true,
      meta: { accessConfig: accessPermission(EMES_ORDERS_ROLES, options) },
    }),
  ]
}
